<template>
  <div class="error-page center">
    <v-card class="mx-auto" max-width="400" elevation="8">
      <v-card-title class="d-flex align-center">
        <v-icon large left color="error"> mdi-alert-circle </v-icon>
        <span class="text-h5 font-weight-bold ml-2">404 - Page Not Found</span>
      </v-card-title>

      <v-card-text class="text-center py-6">
        <v-icon x-large color="error" class="mb-4">mdi-map-marker-off</v-icon>
        <p class="text-h6 mb-2" style="color: #d32f2f">{{ message }}</p>
        <p class="text-body-1 text-grey-darken-1">
          The page you're looking for might have been removed, had its name changed, or is
          temporarily unavailable.
        </p>
      </v-card-text>

      <v-card-actions class="justify-center pb-6">
        <v-btn
          color="primary"
          variant="flat"
          :to="{ name: 'dashboard' }"
          prepend-icon="mdi-home"
          size="large"
        >
          Go to Dashboard
        </v-btn>
        <v-btn
          color="secondary"
          variant="outlined"
          @click="$router.go(-1)"
          prepend-icon="mdi-arrow-left"
          size="large"
          class="ml-4"
        >
          Go Back
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";

// Props
const props = defineProps({
  errorCode: {
    type: String,
    default: "404",
  },
  customMessage: {
    type: String,
    default: "",
  },
});

const route = useRoute();

// Computed message
const message = computed(() => {
  if (props.customMessage) {
    return props.customMessage;
  }

  const errorMessages = {
    404: "Sorry, the page you're looking for doesn't exist.",
    403: "You don't have permission to access this page.",
    500: "Internal server error. Please try again later.",
  };

  return errorMessages[props.errorCode] || "An error occurred.";
});

// Error code from route params
const errorCode = computed(() => route.params.code || props.errorCode);
</script>

<style scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 20px;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}
</style>
